'use client';

import React from 'react';
import Slider from '@/components/ui/SliderOld';
import links from './newlinks.json';
import openArrow from '../../../public/images/arrow-up-right-from-square.png';

const IndustryHighlights: React.FC = () => {
  return (
    <Slider showArrows={false} showDots autoPlay autoPlayInterval={15000} infinite>
      {links.map((item, index) => (
        <div key={index} className="max-w-6xl mx-auto px-4 h-full flex">
          <div className="bg-white rounded-lg shadow-lg border border-[#E1EEFE] p-6 overflow-auto flex-1 flex flex-col">
            <div className="flex flex-col lg:flex-row gap-6 lg:items-start min-w-0 flex-1">
              {/* Image */}
              <div className="flex-shrink-0 lg:self-start md:py-2">
                <div className="rounded-lg max-w-full lg:max-w-[360px] flex items-start justify-center">
                  <img src={item.image} alt={item.title} className="max-w-full max-h-full object-contain" />
                </div>
              </div>

              {/* Content */}
              <div className="flex-1 min-w-0 max-w-full lg:text-left text-center flex flex-col">
                <div
                  className="text-2xl text-[#212A31] font-medium leading-8 break-words mb-2"
                  dangerouslySetInnerHTML={{ __html: item.title }}
                />
                <div className="text-[#486075] text-base font-normal leading-6 mb-3 break-words">
                  Source: {item.source}
                </div>
                <div className="text-[#212A31] text-[1rem] font-normal mb-4 leading-[140%] sm:leading-[160%] break-words">
                  {item.description}
                </div>

                <a href={item.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#2067F3] font-medium text-[1rem] inline-flex items-center md:gap-2.5 self-center lg:self-start"
                >
                  <img
                    src={openArrow.src}
                    alt={item.title}
                    className="w-7 h-7 flex-shrink-0"
                  />
                  <span className="leading-tight">{item.button}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      ))}
    </Slider>
  );
};

export default IndustryHighlights;
